export namespace ICarPopupTables {
  export enum Command {
    GetCameras = 'MOVHISTORY',
    GetEventsLog = 'EventsLog',
    GetMovements = 'MOVS',
  }

  export enum CarPopupTables {
    movHistory = 'movHistory',
    eventsLog = 'eventsLog',
    movements = 'movs',
  }

  export enum CarPopupTab {
    Info = 'info',
    Movements = 'movements',
    Camera = 'camera',
    Balance = 'balance',
    Archive = 'archive',
    AntiTheft = 'antiTheft',
  }

  export const CarPopupTableArrayName = {
    [Command.GetCameras]: CarPopupTables.movHistory,
    [CarPopupTab.Camera]: CarPopupTables.movHistory,

    [Command.GetEventsLog]: CarPopupTables.eventsLog,
    [CarPopupTab.Archive]: CarPopupTables.eventsLog,

    [Command.GetMovements]: CarPopupTables.movements,
    [CarPopupTab.Camera]: CarPopupTables.movements,
  };

  export interface ICarTableParams {
    command: Command;
    carNumber?: string;
    fltDateBeg?: string;
    fltDateEnd?: string;
    carId?: number;
    payFlag?: boolean;
  }

  export interface ICamerasTableItem {
    camId: number;
    camName: string;
    camTime: string;
    event: string;
    hasPhoto?: boolean;
  }

  export interface IArchiveTableItem {
    DateEvent: string;
    eventName: string;
    persName: string;
  }
}